<div class="full-width-text">
  <div class="slider-text-container">
    <div class="slider-title">{{title | translate}}</div>
    <div class="slider-detail">{{detail | translate}}</div>
  </div>
</div>
